import { createApp } from '@app/adapters/create-app'

import PulseCommunication from '../sections/communication/components/pulse-communication'
import createStore from '../sections/communication/store'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour~='pulse-communication']").each(function () {
    const { ledgerId, ledgerPeriodName } = this.dataset

    const endpointParams = {
      ledgerId,
      ledgerPeriodName,
      pulseScope: true,
    }

    const pulseCommunicationApp = createApp(PulseCommunication)
    pulseCommunicationApp.use(createStore(endpointParams))

    pulseCommunicationApp.mount(this)
  })
})
